<script>
	// NPM Modules
	import Dropzone from 'svelte-file-dropzone';
	// Components
	import Icon from '@/Components/Icon.svelte';

	export let image = undefined;
	export let imageUrl = undefined;
	export let newImage = undefined;

	$: displayImage = newImage || imageUrl;

	function clear() {
		if (newImage) {
			newImage = null;
		} else {
			image = null;
		}
	}

	/**
	 * FileReader.readAsDataURL method compatible with:
	 * Chrome 13+, Edge 12+, Firefox 3.6+, Internet Explorer 10+, Safari 6+
	 */
	function fileChange(e) {
		handleFileUpload(e.target.files[0]);
	}

	function handleFileUpload(file) {
		let reader = new FileReader();

		reader.onloadend = function () {
			newImage = reader.result;
		};

		if (file) {
			reader.readAsDataURL(file);
		} else {
			newImage = null;
		}
	}

	function handleFilesSelect(e) {
		const { acceptedFiles } = e.detail;
		dragging = false;
		handleFileUpload(acceptedFiles[0]);
	}

	$: dragging = false;
	function draggingEnter() {
		dragging = true;
	}
	function draggingLeave() {
		dragging = false;
	}
</script>

<div
	class="relative w-56 bg-center bg-no-repeat bg-contain border border-gray-500 border-dashed btn-hover h-15 min-h-15"
	style={displayImage && !dragging ? `background-image: url(${displayImage})` : ''}
>
	<Dropzone
		on:drop={handleFilesSelect}
		containerClasses="custom-dropzone"
		on:dragenter={draggingEnter}
		on:dragleave={draggingLeave}
		noClick
	>
		{#if dragging}
			<div class="flex items-center justify-around w-full h-full text-xl text-black bg-gray-100 bg-opacity-100">
				<h1>Drop to add file</h1>
			</div>
		{:else}
			<div class="flex items-center justify-around invisible bg-black bg-opacity-50 on-btn-hover w-full h-full">
				{#if image}
					<button
						on:click={clear}
						class="text-gray-500 btn hover:text-gray-300"
						title={newImage ? 'Revert Image' : 'Remove Image'}
					>
						<Icon name={newImage ? 'revert' : 'cross-box'} />
					</button>
					<a
						href={image}
						target="_blank"
						rel="noreferrer"
						class="text-gray-500 btn hover:text-gray-300"
						title="Preview"
					>
						<Icon name="zoom" />
					</a>
				{/if}
				<label>
					<span class="text-gray-500 cursor-pointer btn hover:text-gray-300" title="Upload Image">
						<Icon name="pencil" />
					</span>
					<input class="hidden" type="file" on:change={fileChange} accept=".png,.jpg,.jpeg,.gif" />
				</label>
			</div>
		{/if}
	</Dropzone>
</div>

<style>
	:global(.custom-dropzone) {
		padding: 0 !important;
		border: 0 !important;
		background-color: transparent !important;
		transition: none !important;
		border-radius: 0 !important;
		height: 100% !important;
	}
</style>
